const SectionHeader = (props) => {
  return (
    <h2 className="sm:text-xl text-md font-bold text-fuchsia-500">{props.title}</h2>
  )
}

export default SectionHeader